module.exports = require("mappersmith/middlewares/encode-json");


/*****************
 ** WEBPACK FOOTER
 ** external "mappersmith/middlewares/encode-json"
 ** module id = 1
 ** module chunks = 0
 **/